export default {
  'educator-practices': true,
  'schoolwide-practices': true,
  'student-activities': true,
}
